import { authHeader } from '../_helpers';

const baseDomain = process.env.REACT_APP_DATA_SUBDOMAIN + "." + process.env.REACT_APP_DOMAIN;

export const pipelineService = {
    launchPipeline
};

function launchPipeline(token, sport) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(token)
    };

    return fetch('https://' + baseDomain + '/pipeline/launch/' + sport, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) { 
        return Promise.reject(response.statusText);
    }

    return response.json();
}



// WEBPACK FOOTER //
// ./src/_services/pipeline.js